module.exports = __webpack_public_path__ + "img/user-icon.66e7e603.png";